import type { ReactNode } from 'react';

import styles from './ServiceDropdown.module.scss';
import { Dropdown } from '../../forms/Dropdown';
import type { DropdownProps } from '../../forms/Dropdown';
import type { FloatingMenuItem } from '../../forms/FloatingMenu';

import { ServiceIcon } from '../ServiceIcon';

type Props = DropdownProps & {
  /**
   * Consumer supplied function that returns an icon image URL for a given menu item.
   * This is necessary because services do not curently support SVG icons, only raster icons.
   */
  getIconUrlForItem: (item: FloatingMenuItem) => string;
  getLabelForItem: (item: FloatingMenuItem) => string;
};

/**
 * A custom version of `Dropdown` for selecting a service. Renders icons appropriate for each service.
 */
export const ServiceDropdown = ({ getIconUrlForItem, ...props }: Props) => {
  const renderIcon = (item: FloatingMenuItem): ReactNode =>
    !!item && (
      <span
        className={styles.serviceIcon}
        data-disabled={props.isDisabled ? true : undefined}
        data-zds
      >
        <ServiceIcon
          aria-hidden={true}
          serviceName={props.getLabelForItem(item)}
          size="small"
          src={getIconUrlForItem(item)}
        />
      </span>
    );
  return <Dropdown {...props} renderIcon={renderIcon} />;
};
